import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import {
  fetchLinksList,
  addLink,
  clearAddLink,
} from 'redux/links/actions';

import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form } from 'semantic-ui-react';

import TextField from 'components/redux-form-adapters/TextField';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import validate from './validate';
import { fixURL } from 'utils/fixURL';

import './AddLinkForm.css';


const AddLinkForm = props => {
  const {
    handleSubmit,
    valid,
    fetchLinksList,
    addLink,
    clearAddLink,
    addLinkSuccess,
    addLinkError,
    reset,
    url,
 } = props;

  useEffect(() => {
    return () => {
      clearAddLink();
    };
  }, []);

  useEffect(() => {
    fetchLinksList();
  }, [addLinkSuccess]);

  const _handleSubmit = values => {
    const urlValue = fixURL(values.url);
    addLink(urlValue);
    clearAddLink();
    reset();
  };

  const { t } = useTranslation();

  return (
    <div className="add-link-form__component">
      <Form
        onSubmit={handleSubmit(_handleSubmit)}
        error={!valid}
      >
        {/* Url */}
        <div className="field-wrapper">
          <div className="icon" />
          <Field
            component={TextField}
            name="url"
            type="text"
            placeholder={t("Paste your link here")}
            required
          />
          <Button
            submit
            disabled={!url || !valid}
          >
            {t("Add")}
          </Button>
        </div>

        <Button
          submit
          disabled={!url || !valid}
        >
        <div className="button-text-wrapper">
          <div className="text-plus">+</div>
          <div>{t("Add New Link")}</div>
        </div>
        </Button>

      </Form>

      {addLinkError &&
        <CommonMessage
          error
          errors={addLinkError}
        />
      }
    </div>
  );
};

AddLinkForm.propTypes = {
  fetchLinksList: PropTypes.func.isRequired,
  addLink: PropTypes.func.isRequired,
  clearAddLink: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  addLinkSuccess: PropTypes.bool,
  addLinkError: PropTypes.object,
  valid: PropTypes.bool.isRequired,
  url: PropTypes.string,
};

AddLinkForm.defaultProps = {
  addLinkSuccess: null,
  addLinkError: null,
  url: null,
};

const mapStateToProps = (state) => {
  const selector = formValueSelector('AddLinkForm');
  return {
    url: selector(state, 'url'),
    addLinkSuccess: state.linksReducer.addLinkSuccess,
    addLinkError: state.linksReducer.addLinkError,
  };
};

export default connect(
  mapStateToProps,
  {
    fetchLinksList,
    addLink,
    clearAddLink,
  },
)(reduxForm({
  form: 'AddLinkForm',
  validate,
})(AddLinkForm));
